import {
    LpsActivityApiModel,
    LpsConstraintApiModel,
    LpsWeeklyPlanApiModel,
} from '@/core/models/api/lps.model';

export interface LpsState {
    activities: LpsActivityApiModel[];
    constraints: LpsConstraintApiModel[];
    weeklyPlan: LpsWeeklyPlanApiModel[];
    milestones: LpsActivityApiModel[];
    ppc: any | null;
    cncAnalysis: any | null;
    loading: boolean;
    errorMessage: string | null;
}

export const initialLpsState: LpsState = {
    activities: [],
    constraints: [],
    weeklyPlan: [],
    milestones: [],
    ppc: null,
    cncAnalysis: null,
    loading: false,
    errorMessage: null
};
